import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";

@Injectable()
export class BrokerApiWidgetAdapter {
	adaptListData = (): HorizontalListData[] => {
		return [
			HorizontalListFactory.createKeyValueCustomValueTemplateItem({
				title: 'Enabled',
				customTemplateName: 'enabledCheckBoxValue'
			}),
		]
	}
}
